import { DisplayItem, RewardType } from "components/DIP/types";
import { Rewards } from "interfaces";

export const getDisplayRewards = (
	rewardId: string,
	{ rewards, rewardTypes }: { rewards: Rewards; rewardTypes: RewardType[] }
) => {
	if (!rewards || !rewardTypes?.length) {
		return [];
	}
	const items = rewards[rewardId]?.items;
	const displayRewards: DisplayItem["rewards"] = [];
	if (!items) {
		return [];
	}
	for (const [rewardItemId, units] of Object.entries(items)) {
		rewardTypes.forEach(({ id, imageUrl, pluralLabel, singularLabel }) => {
			if (id === rewardItemId) {
				displayRewards.push({
					id,
					imageUrl: imageUrl,
					description: units.toLocaleString("en-US"),
					pluralLabel,
					singularLabel
				});
			}
		});
	}

	return displayRewards;
};
